// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bloc-page {
  min-height: 800px;
}

.pbtndrag > button {
  width: 2rem !important;
  height: 2rem !important;
}

.content-ordre {
  background: url('bg-noise.662e9a7b0a65a925.png');
  color: var(--primaryTextColor);
  z-index: 5;
  width: 40px;
  height: 40px;
  padding: 10px;
  text-align: center;
}

.upload-container {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  margin: 2px 0px 20px 0px;
  height: 120px;
  padding-top: 10px !important;
}

.upload-container-input {
  border: 2px dashed #ccc;
  text-align: center;
  margin: 20px 0;
  height: 120px;
}

.upload-container-input:focus-within {
  border: 2px dashed #838181;
}

.notif-taille {
  text-align: center;
  color: #a10a0a;
  font-size: 10pt;
}

.dixfilename {
  text-align: left !important;
  margin: auto;
}

.btnDetailPlan {
  text-align: right;
  margin: auto;
}

.gridDetailPlan {
  /* margin: .5rem !important; */
  margin-top: 1.5rem;
}

.flex-auto-max-width {
  max-width: 300px;
}

.img-upload-plan {
  visibility: hidden;
}

.plan-detail-width {
  width: 100%;
}

.field-max-width {
  max-width: 500px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
